module.exports = "images/france-4.3ca64564.png";